import React, { Component } from "react";
import { Container, Row, Col, Form, Input } from "reactstrap";
import Title from "../Title";
import Button from "../Button";
import axios from "axios";
import GoogleMapReact from "google-map-react";
import config from "../../../config";
import "./styles.css";

import Marker from "./Pointer";

export default class LayoutContactMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "",
      name: "",
      email: "",
      message: ""
    };
    this.handleChange = this.handleChange.bind(this);
    this.setMessage = this.setMessage.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    this.setState({ status: this.validadeState() ? "ok" : "" });
  }

  validadeState() {
    const emailRE = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (this.state.name.length < 4) return false;
    if (!emailRE.test(this.state.email)) return false;
    if (this.state.message.split(" ").length < 5) return false;

    return true;
  }

  setMessage() {
    this.setState({ status: "loading" });
    // no content saved lets fecth it fromjson
    var params = new URLSearchParams();
    params.append("email", this.state.email);
    params.append("name", this.state.name);
    params.append("message", this.state.message);

    axios
      .post(`${config.apiURL}/wp-json/mail/v1/contact`, params)
      .then(result => {
        if (result.data.status === "OK") {
          this.setState({ status: "success" });
        } else {
          this.setState({ status: "error" });
        }
      })
      .catch(error => {
        this.setState({ status: "error" });
      });
  }

  renderForm() {
    const {
      title,
      form,
      content,
      error,
      button_text,
      email,
      message,
      name
    } = this.props.content;
    return (
      <div>
        {this.state.status !== "error" ? (
          <Title>{title}</Title>
        ) : (
          <Title>
            <strong>{error}</strong>
          </Title>
        )}

        <Form>
          <Row>
            <Col>
              <Input
                type={"text"}
                name={"name"}
                onChange={this.handleChange}
                value={this.state.name}
                placeholder={name}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Input
                type={"email"}
                name={"email"}
                onChange={this.handleChange}
                value={this.state.email}
                placeholder={email}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Input
                type="textarea"
                name="message"
                onChange={this.handleChange}
                value={this.state.message}
                placeholder={message}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                disabled={
                  this.state.status !== "ok" && this.state.status !== "error"
                }
                onClick={() => this.setMessage()}
              >
                {button_text} <i className={"icons icon-paper-plane"} />
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
  renderThankyou() {
    return (
      <Title>
        <strong>{this.props.content.success}</strong>
      </Title>
    );
  }
  renderLoading() {
    return (
      <Title>
        <strong>{this.props.content.sending}</strong>
      </Title>
    );
  }
  render() {
    let body = {};
    switch (this.state.status) {
      case "success":
        body = this.renderThankyou();
        break;
      case "loading":
        body = this.renderLoading();
        break;
      default:
        body = this.renderForm();
        break;
    }
    return (
      <div className={"contacts"}>
        <Row>
          <Col xs="12" md="6">
            <div className={"map-container"}>
              <GoogleMapReact
                bootstrapURLKeys={{
                  key: "AIzaSyBMsImhpIrlyFwko7qiJ-nl6bAOtAwwCfc"
                }} // set if you need stats etc ...
                center={[
                  Number(this.props.content.map.lat),
                  Number(this.props.content.map.lng)
                ]}
                zoom={17}
              >
                <Marker
                  lat={Number(this.props.content.map.lat) + 0.001}
                  lng={Number(this.props.content.map.lng) - 0.001}
                  text={this.props.content.content}
                />
              </GoogleMapReact>
            </div>
          </Col>
          <Col xs="12" md="6">
            <div className={"contactus-container"}>{body}</div>
          </Col>
        </Row>
      </div>
    );
  }
}
